export default __webpack_public_path__ + "static/media/prev_disabled.0c664b97.svg";